import * as types from './mutation-types'
const mutations = {
  // 显示header
  [types.showHomeHeader] (state, showHomeHeader) {
    state.showHomeHeader = showHomeHeader
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js